import {
  ConnectionListResult,
  GridSortProps,
  PaginatedQueryWrapper,
} from '@tableau/data-catalog-shared';
import * as React from 'react';

import { Messages } from '../../../gen-src/Localize';
import {
  VirtualConnectionTableDownstreamSheetsFilteredByColumnQuery,
  VirtualConnectionTableDownstreamSheetsFilteredByColumnQuery_virtualConnectionTables_columnsConnection_nodes_downstreamSheetsConnection_nodes,
  VirtualConnectionTableDownstreamSheetsFilteredByColumnQueryVariables,
} from '../../../gen-src/queries/VirtualConnectionTableDownstreamSheetsFilteredByColumnQuery';
import {
  VirtualConnectionTableDownstreamSheetsQuery,
  VirtualConnectionTableDownstreamSheetsQuery_virtualConnectionTables_downstreamSheetsConnection_nodes,
  VirtualConnectionTableDownstreamSheetsQueryVariables,
} from '../../../gen-src/queries/VirtualConnectionTableDownstreamSheetsQuery';
import { SheetSortOrder } from '../../../gen-src/queries/globalTypes';
import { VirtualConnectionTableDownstreamSheetsFilteredByColumnQueryGql } from '../../queries/VirtualConnectionTableDownstreamSheetsFilteredByColumnQueryGql';
import { VirtualConnectionTableDownstreamSheetsQueryGql } from '../../queries/VirtualConnectionTableDownstreamSheetsQueryGql';
import { getRowDataForSheet, SheetsDisplayGrid, SheetsDisplayGridRowData } from '../sharedDisplayGrid/SheetsDisplayGrid';
import { SheetsValidSortFields } from '../sorting/sortProviders/SheetsGridSortProvider';


type QueryVariables = VirtualConnectionTableDownstreamSheetsQueryVariables;
type QueryResults = VirtualConnectionTableDownstreamSheetsQuery;
type QueryResultListNode = VirtualConnectionTableDownstreamSheetsQuery_virtualConnectionTables_downstreamSheetsConnection_nodes;
type GridRowData = SheetsDisplayGridRowData;

type QueryVariablesWithFilter = VirtualConnectionTableDownstreamSheetsFilteredByColumnQueryVariables;
type QueryResultsWithFilter = VirtualConnectionTableDownstreamSheetsFilteredByColumnQuery;
type QueryResultListNodeWithFilter =
  VirtualConnectionTableDownstreamSheetsFilteredByColumnQuery_virtualConnectionTables_columnsConnection_nodes_downstreamSheetsConnection_nodes;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData && resultData.virtualConnectionTables && resultData.virtualConnectionTables[0] &&
    resultData.virtualConnectionTables[0].downstreamSheetsConnection;
}

function selectConnectionListResultForFilteredQuery(
  resultData: QueryResultsWithFilter
): ConnectionListResult<QueryResultListNodeWithFilter> | null {
  const virtualConnection = resultData && resultData.virtualConnectionTables && resultData.virtualConnectionTables[0];
  const virtualConnectionTableColumns = virtualConnection && virtualConnection.columnsConnection && virtualConnection.columnsConnection.nodes;
  const column = virtualConnectionTableColumns && virtualConnectionTableColumns[0];
  return column ? column.downstreamSheetsConnection : null;
}

export type VirtualConnectionTableDownstreamSheetsQueryGridProps = GridSortProps<SheetsValidSortFields> & {
  readonly vizportalUrlId: string;
  readonly filteredColumnId: string | null;
  readonly rowCount: number | null;
};

export function VirtualConnectionTableDownstreamSheetsQueryGrid(props: VirtualConnectionTableDownstreamSheetsQueryGridProps): JSX.Element {
  const emptyGridMessage = Messages.EmptyDownstreamSheetsLineageGridMessage();
  const emptyFilteredGridMessage = Messages.EmptyDownstreamFilteredSheetsLineageGridMessage();

  return props.filteredColumnId ? (
    // Query with Selected Sheet as Filter
    <PaginatedQueryWrapper<QueryVariablesWithFilter, QueryResultsWithFilter, QueryResultListNode, GridRowData>
      queryGql={VirtualConnectionTableDownstreamSheetsFilteredByColumnQueryGql}
      partialQueryVariables={{
        vizportalUrlId: props.vizportalUrlId,
        selectedColumnId: props.filteredColumnId,
        orderBy: props.orderBy as SheetSortOrder,
      }}
      selectConnectionListResult={selectConnectionListResultForFilteredQuery}
      mapResultNode={getRowDataForSheet}
    >
      {({ rowStore }) =>
        <SheetsDisplayGrid
          rowStore={rowStore}
          emptyGridMessage={emptyFilteredGridMessage}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />
      }
    </PaginatedQueryWrapper>
  ) : (
    // Query without Selection
    <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
      queryGql={VirtualConnectionTableDownstreamSheetsQueryGql}
      partialQueryVariables={{
        vizportalUrlId: props.vizportalUrlId,
        orderBy: props.orderBy as SheetSortOrder,
      }}
      selectConnectionListResult={selectConnectionListResult}
      mapResultNode={getRowDataForSheet}
    >
      {({ rowStore }) =>
        <SheetsDisplayGrid
          rowStore={rowStore}
          emptyGridMessage={emptyGridMessage}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />}
    </PaginatedQueryWrapper>
  );
}
